<mat-drawer-container class="absoluteFill customDrawer" [hasBackdrop]="false">

  <mat-drawer class="detailsPanelContainer" [opened]="!!expandedElement" position="end" [mode]="'over'" >
    <div class="detailsPanel">
      <mat-toolbar class="detailsPanelToolbar">
        <div fxFlex fxLayout="column">
          <span class="detailsPanelToolbarTitle" fxFlex>{{expandedElement?.email}}</span>
          <span class="detailsPanelToolbarSubtitle" fxFlex>{{'USER.DETAILS' | translate}}</span>
        </div>
        <button mat-icon-button color="accent" (click)="expandedElement = undefined">
          <mat-icon>close</mat-icon>
        </button>
        <section class="floatingUpdateButton">
          <button mat-fab color="primary" *ngIf="!editMode" (click)="editMode = true">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-fab color="primary" style="margin-right: 15px;" *ngIf="editMode" [disabled]="!formValidationOk" (click)="updateUser()">
            <mat-icon>done</mat-icon>
          </button>
          <button mat-fab color="primary" *ngIf="editMode" (click)="editMode = false">
            <mat-icon>close</mat-icon>
          </button>
        </section>
      </mat-toolbar>

      <app-e015-user-detail fxFlex
                                (close)="hideElement()"
                                (validForm)="manageFormValidation($event)"
                                [editMode]="editMode"
                                [selectedRow]="expandedElement"
      ></app-e015-user-detail>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <div class="drawerContent absoluteFill" fxLayout="column">
      <div fxFlex class="mat-elevation-z8 table-container" fxLayout="column" *ngIf="!!users">

        <!-- ####################################################################################################### -->
        <!-- Main Toolbar                                                                                            -->
        <!-- ####################################################################################################### -->
        <mat-toolbar class="tableToolbar" fxLayout="row" *ngIf="!searchEnabled">
          <span fxFlex>
            Utenti E015
          </span>
          <div fxFlex class="tableToolbarButtons">
            <button mat-icon-button color="primary" (click)="addNewUser()">
              <mat-icon>add</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="getE015Users()">
              <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="searchEnabled = true">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </mat-toolbar>

        <!-- ####################################################################################################### -->
        <!-- Search Toolbar                                                                                          -->
        <!-- ####################################################################################################### -->
        <mat-toolbar class="tableToolbar" fxLayout="row" *ngIf="searchEnabled">

          <mat-form-field fxFlex>
            <mat-label>&emsp;</mat-label>

            <input matInput placeholder="{{'USER.SEARCH' | translate}}" type="text" autofocus name="userLastName" #filterValue="ngModel"
                   [(ngModel)]="userNameToFind" (keyup.enter)="getE015Users()">

          </mat-form-field>

          <button mat-icon-button color="primary" (click)="searchEnabled = false; userNameToFind = undefined; getE015Users()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-toolbar>

        <div class="table-container">
          <table mat-table [dataSource]="tableDataSource" aria-describedby="customerUsers">

            <!-- User email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> {{'USER.EMAIL' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- User firstname Column -->
            <ng-container matColumnDef="firstname">
              <th mat-header-cell *matHeaderCellDef> {{'USER.FIRSTNAME' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.firstname}} </td>
            </ng-container>

            <!-- User lastname Column -->
            <ng-container matColumnDef="lastname">
              <th mat-header-cell *matHeaderCellDef> {{'USER.LASTNAME' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.lastname}} </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [ngClass]="(gmService.isMobileScreen() || gmService.isTenantUser()) ? 'smallIcons' : 'normalIcons'">

                <!-- COLLAPSED ICONS -->
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation();" *ngIf="gmService.isMobileScreen()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item color="primary" (click)="resetPassword(element); $event.stopPropagation();"
                          [title]="'USER.RESET_PASSWORD' | translate" aria-label="Reset password">
                    <mat-icon mat-list-icon>key</mat-icon> {{'USER.RESET_PASSWORD' | translate}}
                  </button>
                  <button mat-menu-item color="primary" (click)="deleteUser(element); $event.stopPropagation();"
                          [title]="'USER.DELETE' | translate" aria-label="Elimina utente">
                    <mat-icon mat-list-icon>delete</mat-icon> {{'USER.DELETE' | translate}}
                  </button>
                </mat-menu>

                <!-- INLINE ICONS -->

                <div *ngIf="!gmService.isMobileScreen()">
                  <button mat-icon-button color="primary" (click)="resetPassword(element); $event.stopPropagation();"
                          [title]="'USER.RESET_PASSWORD' | translate" aria-label="Reset password">
                    <mat-icon>key</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" (click)="deleteUser(element); $event.stopPropagation();"
                          [title]="'USER.DELETE' | translate" aria-label="Elimina utente">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="showDetail(row)"
                [ngClass]="{'highlight': expandedElement?.id == row.id}"
                *matRowDef="let row; columns: displayedColumns;"></tr>

            <!--  ************************************  -->
            <!--               NO DATA ROW              -->
            <!--  ************************************  -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [colSpan]="displayedColumns.length">{{'COMMON.NO_DATA_FOUND' | translate }}</td>
            </tr>
          </table>

          <div *ngIf="e015UsersLoading"
               style="display: flex; justify-content: center; align-items: center; background: white;">
            <mat-progress-spinner
              [diameter]="40"
              color="primary"
              mode="indeterminate">
            </mat-progress-spinner>
          </div>
        </div>

        <mat-divider></mat-divider>
        <mat-paginator class="paginatorCustom" showFirstLastButtons (page)="getPaginatorData($event)" [length]="totalElements"
                       [pageSize]="pageSize" [pageSizeOptions]="PAGESIZE_OPTIONS"></mat-paginator>

      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
